// Help generate valid URL
jqueryForm.addEnhancement(function()
{
    if (this.form.data('enhanced')) {
        return;
    }

    var setClass = function(key, input)
    {
        var $input = $(input);
        if (input.value.length) {
            $input.addClass('has-value');
        } else {
            $input.removeClass('has-value');
        }
    };

    this.form.find('input, textarea').each(setClass);

    this.form.on('input', 'input, textarea', function()
    {
        setClass(null, this);
    });
});
